<div *ngIf="items?.length || !hideOnEmpty"
     class="selector-icon pointer {{styleClass}}"
     [class.disabled]="!items?.length">
  <ng-container *ngIf="buttonMode; else defaultView">
    <!--    TODO buttonMode-->
    <!--    <div class="si-button-action" (click)="onClickIcon($event)">-->
    <!--      <span class="si-button-action_text">{{iconText | translate}}</span>-->
    <!--    </div>-->
  </ng-container>
  <ng-template #defaultView>
    <div siPreventDoubleClick
         class="selector-icon_icon"
         pTooltip="{{iconText | translate}}"
         tooltipPosition="top"
         (click)="onClickIcon($event)">
      <i class="{{icon}} font-color-main1 {{iconClass}}"></i>
    </div>
  </ng-template>
  <si-selector-custom [hideSelectorCustom]="true"
                      [text]="iconText"
                      [values]="items"
                      [openTop]="openTop"
                      [disabled]="!items?.length"
                      (modelChange)="onSelectItem($event)">
    <button #itemSelectorButton [hidden]="true"></button>
  </si-selector-custom>
</div>
